import { render, staticRenderFns } from "./ReportUserAndProduct.vue?vue&type=template&id=ca992622&"
import script from "./ReportUserAndProduct.vue?vue&type=script&lang=js&"
export * from "./ReportUserAndProduct.vue?vue&type=script&lang=js&"
import style0 from "./ReportUserAndProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports